import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrzyciskIkonaComponent } from './komponenty/przycisk-ikona/przycisk-ikona.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatLegacySliderModule } from '@angular/material/legacy-slider';
import { IkonaSvgDirective } from './directives/ikona-svg.directive';
import { PrzewijanyKomponentComponent } from './komponenty/przewijany-komponent/przewijany-komponent.component';
import { RerenderDirective } from './directives/rerender.directive';
import { PrzyciskMydloComponent } from './komponenty/przycisk-mydlo/przycisk-mydlo.component';
import { PrzyciskOkraglyComponent } from './komponenty/przycisk-okragly/przycisk-okragly.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MMOdkazHtmlPipe } from './pipes/mm-odkaz-html.pipe';
import { DlugieNazwyComponent } from './komponenty/dlugie-nazwy/dlugie-nazwy.component';
import { FormatowanieInformacjiOObiekcieDirective } from './directives/formatowanie-informacji-o-obiekcie.directive';
import { ImgDirective } from './directives/img.directive';
import { AudioDirective } from './directives/audio.directive';
import { VideoDirective } from './directives/video.directive';
import { PrzyciskProstokatnyComponent } from './komponenty/przycisk-prostokatny/przycisk-prostokatny.component';
import { KontaktFormularzComponent } from './komponenty/kontakt-formularz/kontakt-formularz.component';
import { TranslateModule } from "@ngx-translate/core";
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MMKomponentHostDirective } from './directives/mm-komponent-host.directive';
import { LogoComponent } from './komponenty/logo/logo.component';
import { CheckboxComponent } from './komponenty/checkbox/checkbox.component';
import { UnderConstructionComponent } from './komponenty/under-construction/under-construction.component';
import { SelectInputComponent } from './komponenty/select-input/select-input.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { AutofocusDirective } from './directives/autofocus.directive';
import { PomocFormularzComponent } from './komponenty/pomoc-formularz/pomoc-formularz.component';
import { PomocSzczegolyComponent } from './komponenty/pomoc-szczegoly/pomoc-szczegoly.component';
import { FormatowanieOpisuDlugiegoDirective } from './directives/formatowanie-opisu-dlugiego.directive';
import { KomunikatCookieComponent } from './komponenty/cookie/komunikat-cookie/komunikat-cookie.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AudioPlayerComponent } from './komponenty/audio-player/audio-player.component';
import { ExpandablePanelComponent } from './komponenty/expandable-panel/expandable-panel.component';
import { PobieranieDanychDialogComponent } from './komponenty/pobieranie-danych-dialog/pobieranie-danych-dialog.component';

@NgModule({
  declarations: [
    AudioPlayerComponent,
    PrzyciskIkonaComponent,
    IkonaSvgDirective,
    KomunikatCookieComponent,
    MMOdkazHtmlPipe,
    PrzewijanyKomponentComponent,
    RerenderDirective,
    PrzyciskMydloComponent,
    PrzyciskOkraglyComponent,
    DlugieNazwyComponent,
    FormatowanieInformacjiOObiekcieDirective,
    FormatowanieOpisuDlugiegoDirective,
    ImgDirective,
    AudioDirective,
    VideoDirective,
    PrzyciskProstokatnyComponent,
    KontaktFormularzComponent,
    MMKomponentHostDirective,
    LogoComponent,
    CheckboxComponent,
    UnderConstructionComponent,
    SelectInputComponent,
    AutofocusDirective,
    PomocFormularzComponent,
    PomocSzczegolyComponent,
    ExpandablePanelComponent,
    PobieranieDanychDialogComponent,
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatLegacySliderModule,
    MatOptionModule,
    MatTooltipModule,
    TranslateModule,
    RouterModule,
    MatTooltipModule,
    // ObserversModule,
    MatSnackBarModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    FormsModule,
    MatSelectModule,
    MatProgressSpinnerModule
  ],
  exports: [
    AudioDirective,
    AudioPlayerComponent,
    AutofocusDirective,
    CheckboxComponent,
    DlugieNazwyComponent,
    ExpandablePanelComponent,
    FormatowanieInformacjiOObiekcieDirective,
    FormatowanieOpisuDlugiegoDirective,
    IkonaSvgDirective,
    // ImageCompareComponent,
    ImgDirective,
    KomunikatCookieComponent,
    KontaktFormularzComponent,
    LogoComponent,
    MatLegacySliderModule,
    // MatFormFieldModule,
    // ReactiveFormsModule,
    // MatCheckboxModule,
    // FormsModule,
    MMKomponentHostDirective,
    MMOdkazHtmlPipe,
    PobieranieDanychDialogComponent,
    PomocFormularzComponent,
    PomocSzczegolyComponent,
    PrzyciskIkonaComponent,
    PrzyciskMydloComponent,
    PrzyciskOkraglyComponent,
    PrzyciskProstokatnyComponent,
    PrzewijanyKomponentComponent,
    RerenderDirective,
    SelectInputComponent,
    UnderConstructionComponent,
    VideoDirective
  ]
})
export class CommonsModule { }
